import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { Box, Button, IconButton, TextField, Chip, Tooltip } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import * as XLSX from 'xlsx';

const AllMembers = ({ isOnline }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const society_id = location.state && location.state.society_id;
  const society_name = location.state && location.state.name;
  const [everybody, setEverybody] = useState([]);
  const [everybodyin, setEverybodyin] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageid, setMessageid] = useState();
  const { permissions } = useContext(AuthContext);
  const [societies, setSocieties] = useState([]);
  const [association_id_for_update, setAssociation_id_for_update] =
    useState(null);
  const [associations, setAssociations] = useState([]);
  const [members, setMembers] = useState([]);
  const [members_field, setMembers_field] = useState("");
  const [members_field_id, setMembers_field_id] = useState("");
  const [formFields, setFormFields] = useState([
    {
      index_id: 0,
      member_id: null,
      field: null,
    },
  ]);

  function formatDateToYearMonthDay(date) {
    const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
    } else if (day === 2 || day === 22) {
    suffix = "nd";
    } else if (day === 3 || day === 23) {
    suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
}


  const exportToExcel = () => {
    const title = `${society_name} Members List`;
    const headers = [
      "No.", "First Name", "Last Name", "Phone Contact", 
      "Card Number", "Savings Group", "Main Crop", "Language",
      "Land Size", "Community", "Cluster"
    ];
  
    // Prepare data with descending numbering
    const data = [...everybody].reverse().map((row, index) => [
      everybody.length - index,  // Descending number
      row.firstname,
      row.lastname,
      row.phone,
      row.ghcardnumber,
      row.association_name,
      row.main_crop,
      row.farmer_language,
      row.land_size_acres <= 0 || !row.land_size_acres 
        ? "N/A" 
        : `${row.land_size_acres} acres`,
      row.community,
      row.cluster
    ]);
  
    // Combine title, headers, and data into worksheet
    const worksheetData = [
      [title], 
      [`Total Members: ${everybody.length}`],
      [], // Empty row for spacing
      headers, 
      ...data
    ];
  
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    
    // Merge title row cells
    worksheet['!merges'] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }, // Title
      { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } }  // Total members
    ];
    
    // Style title and info rows
    worksheet["A1"].s = {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center" }
    };
    
    worksheet["A2"].s = {
      font: { bold: true, italic: true, sz: 12 },
      alignment: { horizontal: "center" }
    };
  
    // Style headers
    headers.forEach((_, colIndex) => {
      const cell = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      worksheet[cell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "D3D3D3" } } // Light gray background
      };
    });
  
    // Create workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Members");
  
    // Export to Excel
    XLSX.writeFile(workbook, `${society_name} Members List.xlsx`);
  };

  const handlePsb = (row) => {
    navigate("/onemember/", {
      state: {
        Member_id: row.member_id,
        Fullname: `${row.firstname} ${row.middlename ?row.middlename: ""} ${row.lastname?row.lastname:""}`,
      },
    });
  };


  const ResetFields = () => {
    setFormFields([
      {
        index_id: 0,
        member_id: null,
        field: null,
      },
    ]);
  };

  const addFields = () => {
    const maxIndexId = Math.max(
      ...formFields.map((field) => field.index_id),
      0
    );
    const nextIndexId = maxIndexId + 1;

    let new_object = {
      index_id: nextIndexId,
      member_id: null,
      field: null,
    };
    setFormFields([...formFields, new_object]);
  };

  const removeField = (index_id) => {
    const indexToRemove = formFields.findIndex(
      (field) => field.index_id === index_id
    );

    if (indexToRemove !== -1) {
      const updatedFormFields = [...formFields];
      updatedFormFields.splice(indexToRemove, 1);
      setFormFields(updatedFormFields);
    }
  };

  const handleMemberChange = (index, member) => {
    const updatedFormFields = [...formFields];
    updatedFormFields[index].member_id = member.Member_id;
    updatedFormFields[index].field = member[members_field_id];
    setFormFields(updatedFormFields);
  };

  const handlePhoneChange = (index, event, value) => {
    const updatedFormFields = [...formFields];
    if (
      members_field_id === "gender" ||
      members_field_id === "MaritalStatus" ||
      members_field_id === "ruralOrUrban" ||
      members_field_id === "is_farmer"
    ) {
      updatedFormFields[index].field = value;
    } else {
      updatedFormFields[index].field = event.target.value;
    }
    setFormFields(updatedFormFields);
  };

  const handleMassUpdate = () => {
    const data = {
      data: formFields,
      field: members_field_id,
    };
    api
      .post("/members/mass/update/reality", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        // window.location.reload();
        setFormFields([
          {
            index_id: 0,
            member_id: null,
            field: null,
          },
        ]);
        setAssociation_id_for_update(null);
        setSociety_id_for_update(null);
        fetchEverybody();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchMembers = () => {
    api
      .get(`/members/allmembers/for/update/${association_id_for_update}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setMembers(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (association_id_for_update) {
      fetchMembers();
    }
  }, [association_id_for_update]);

  const association_pull = () => {
    api
      .get(`/association/fech/society/associations/${society_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAssociations(response.data?.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    association_pull();
  }, []);

  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //     setOpen(true);
  // };

  // const handleClose = () => {
  //     setOpen(false);
  // };

  const handleClickOpen = (id) => {
    if (permissions && permissions.delete_member === true) {
      setOpen(true);
      setMessageid(id);
    } else {
      toast.error("Not Authorized");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchEverybody = () => {
    const storedSocietyData = localStorage.getItem(
      `society_${society_id}_members`
    );
    const storedIndividualData = localStorage.getItem(
      `society_${society_id}_individuals`
    );

    if (!isOnline) {
      setEverybody(JSON.parse(storedSocietyData));
      setEverybodyin(JSON.parse(storedIndividualData));
    } else {
      toast.promise(
        api
        .get(`/members/all/emem/soc/${society_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: 'Loading Members...',
          success: (response) => {
            setEverybody(response.data.Association_Members);
            setEverybodyin(response.data.Individual_Members);

            localStorage.setItem(
              `society_${society_id}_members`,
              JSON.stringify(response.data.Association_Members)
            );
            localStorage.setItem(
              `society_${society_id}_individuals`,
              JSON.stringify(response.data.Individual_Members)
            );

            return 'Data loading successfully'
          },
          error: (error) => {
            console.log(error);

            return 'An error occurred, Please refresh page'
          }
        }
      )
    }
  };

  useEffect(() => {
    fetchEverybody();
  }, []);

  
  const handleDelete = () => {
    const id = messageid;
    api
      .delete(`/members/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleClose();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchEverybody();
      });
  };

  // console.log(permissions);

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box>
            <Typography
                variant="h3"
                sx={{ textAlign: "center" }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
                <b>{society_name}</b>
            </Typography>
            <Typography
                variant="h3"
                sx={{ textAlign: "center", m: 1 }}
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
                <b>All Members</b>
            </Typography>
          </Box>
          <Accordion sx={{ borderRadius: 2, mb: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              display="flex"
            >
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                sx={{ mr: "auto" }}
              >
                <b>Update Members</b>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={associations}
                    sx={{ width: "100%", m: 1 }}
                    getOptionLabel={(option) => option.association_name}
                    isOptionEqualToValue={(option, value) =>
                      option.association_id === value.association_id
                    }
                    onChange={(event, value) =>
                      setAssociation_id_for_update(value.association_id)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Savings Group"
                        size="small"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Autocomplete
                    id="tags-outlined"
                    options={[
                      { field: "First name", id: "firstname" },
                      { field: "Middle name", id: "middlename" },
                      { field: "Last name", id: "lastname" },
                      { field: "Date of Birth", id: "dob" },
                      { field: "Gender", id: "gender" },
                      { field: "Phone", id: "phone" },
                      { field: "Other Phone", id: "otherPhone" },
                      { field: "Address", id: "address" },
                      { field: "Home Address(GPS)", id: "otherAddress" },
                      {
                        field: "Card number (GH card, voters card etc)",
                        id: "ghcardnumber",
                      },
                      { field: "Other Name", id: "otherName" },
                      { field: "Common name", id: "commonname" },
                      { field: "Marital Status", id: "MaritalStatus" },
                      { field: "Town", id: "Town" },
                      { field: "Rural Or Urban", id: "ruralOrUrban" },
                      { field: "Farmer ?", id: "is_farmer" },
                      { field: "Language", id: "farmer_language" },
                      { field: "Farm Address(GPS)", id: "land_location" },
                      { field: "FLocation Longitude", id: "long" },
                      { field: "FLocation Latitude", id: "lat" },
                      // {'field': 'Main crop', 'id': 'main_crop'},
                    ]}
                    sx={{ m: 1, width: 500 }}
                    getOptionLabel={(option) => option.field}
                    isOptionEqualToValue={(option, value) =>
                      option.field === value.id
                    }
                    onChange={(event, value) => {
                      setMembers_field(value.field);
                      setMembers_field_id(value.id);
                    }}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField {...params} label="Set Field" size="small" />
                    )}
                  />
                </Grid>
                {members_field_id ? (
                  <>
                    <Grid item xs={12} md={12}>
                      {formFields[0] &&
                        formFields.map((form, index) => (
                          <div
                            key={form.index_id}
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <Autocomplete
                              id="tags-outlined"
                              options={members}
                              sx={{ m: 1, width: 220 }}
                              getOptionLabel={(option) => option.Original_pass}
                              isOptionEqualToValue={(option, value) =>
                                option.Member_id === value.Member_id
                              }
                              onChange={(event, value) =>
                                handleMemberChange(form.index_id, value)
                              }
                              filterSelectedOptions
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select member"
                                  size="small"
                                />
                              )}
                            />
                            {formFields[form.index_id] ? (
                              formFields[form.index_id].member_id &&
                              members_field_id === "gender" ? (
                                <Autocomplete
                                  id="tags-outlined"
                                  options={[
                                    { gender: "male" },
                                    { gender: "female" },
                                  ]}
                                  sx={{ m: 1, width: 300 }}
                                  getOptionLabel={(option) => option.gender}
                                  isOptionEqualToValue={(option, value) =>
                                    option.gender === value.gender
                                  }
                                  onChange={(event, value) =>
                                    handlePhoneChange(
                                      form.index_id,
                                      event,
                                      value.gender
                                    )
                                  }
                                  filterSelectedOptions
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      helperText="Select Gender"
                                      size="small"
                                    />
                                  )}
                                />
                              ) : members_field_id === "MaritalStatus" ? (
                                <Autocomplete
                                  id="tags-outlined"
                                  options={[
                                    { status: "Married", id: "married" },
                                    { status: "Single", id: "single" },
                                    { status: "Divorced", id: "divorced" },
                                    { status: "Widowed", id: "widowed" },
                                  ]}
                                  sx={{ m: 1, width: 300 }}
                                  getOptionLabel={(option) => option.status}
                                  isOptionEqualToValue={(option, value) =>
                                    option.status === value.id
                                  }
                                  onChange={(event, value) =>
                                    handlePhoneChange(
                                      form.index_id,
                                      event,
                                      value.id
                                    )
                                  }
                                  filterSelectedOptions
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      helperText="Select Marital Status"
                                      size="small"
                                    />
                                  )}
                                />
                              ) : members_field_id === "ruralOrUrban" ? (
                                <Autocomplete
                                  id="tags-outlined"
                                  options={[
                                    { type: "rural" },
                                    { type: "urban" },
                                  ]}
                                  sx={{ m: 1, width: 300 }}
                                  getOptionLabel={(option) => option.type}
                                  isOptionEqualToValue={(option, value) =>
                                    option.type === value.type
                                  }
                                  onChange={(event, value) =>
                                    handlePhoneChange(
                                      form.index_id,
                                      event,
                                      value.type
                                    )
                                  }
                                  filterSelectedOptions
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      helperText="Select Town type"
                                      size="small"
                                    />
                                  )}
                                />
                              ) : members_field_id === "is_farmer" ? (
                                <Autocomplete
                                  id="tags-outlined"
                                  options={[
                                    { type: "Farmer", id: true },
                                    { type: "Not_Farmer", id: false },
                                  ]}
                                  sx={{ m: 1, width: 300 }}
                                  getOptionLabel={(option) => option.type}
                                  isOptionEqualToValue={(option, value) =>
                                    option.type === value.id
                                  }
                                  onChange={(event, value) =>
                                    handlePhoneChange(
                                      form.index_id,
                                      event,
                                      value.id
                                    )
                                  }
                                  filterSelectedOptions
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      helperText="Is member a Farmer"
                                      size="small"
                                    />
                                  )}
                                />
                              ) : members_field_id === "long" ||
                                members_field_id === "lat" ? (
                                <TextField
                                  size="small"
                                  name={members_field_id}
                                  sx={{ m: 1 }}
                                  type="number"
                                  inputProps={{ step: "any" }}
                                  helperText={members_field}
                                  value={formFields[form.index_id].field}
                                  onChange={(event) =>
                                    handlePhoneChange(
                                      form.index_id,
                                      event,
                                      event.target.value
                                    )
                                  }
                                />
                              ) : (
                                <TextField
                                  size="small"
                                  name={members_field_id}
                                  sx={{ m: 1 }}
                                  type={
                                    members_field_id === "dob" ? "date" : "text"
                                  }
                                  helperText={members_field}
                                  value={formFields[form.index_id].field}
                                  onChange={(event) =>
                                    handlePhoneChange(
                                      form.index_id,
                                      event,
                                      event.target.value
                                    )
                                  }
                                />
                              )
                            ) : null}
                            <IconButton
                              disabled={formFields.length > 1 ? false : true}
                              onClick={() => removeField(form.index_id)}
                            >
                              <RemoveCircleIcon />
                            </IconButton>
                          </div>
                        ))}
                    </Grid>
                    <Grid item xs={12} md={12}>
                      {members[0] && (
                        <>
                          <Button
                            sx={{
                              m: 1,
                              backgroundColor: "#33415c",
                              borderRadius: 4,
                            }}
                            size="small"
                            onClick={addFields}
                            variant="contained"
                          >
                            New Field
                          </Button>
                          <Button
                            sx={{ m: 1, borderRadius: 4 }}
                            color="error"
                            size="small"
                            onClick={ResetFields}
                            variant="contained"
                          >
                            Reset Fields
                          </Button>
                        </>
                      )}
                      {formFields[0] && members_field_id === "is_farmer" ? (
                        <Button
                          disabled={
                            formFields[0].member_id &&
                            (formFields[0].field === true ||
                              formFields[0].field === false)
                              ? false
                              : true
                          }
                          sx={{ m: 1, borderRadius: 4 }}
                          color="success"
                          size="small"
                          onClick={handleMassUpdate}
                          variant="contained"
                        >
                          Update
                        </Button>
                      ) : (
                        <Button
                          disabled={
                            formFields[0].member_id && formFields[0].field
                              ? false
                              : true
                          }
                          sx={{ m: 1, borderRadius: 4 }}
                          color="success"
                          size="small"
                          onClick={handleMassUpdate}
                          variant="contained"
                        >
                          Update
                        </Button>
                      )}
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </AccordionDetails>
          </Accordion>
            <Tooltip title="Download Excel">
              <Button
                onClick={exportToExcel}
                color="success"
                size="medium"
                variant="contained"
                sx={{
                  borderRadius: 2,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                  },
                }}
              >
                <DownloadRoundedIcon />
              </Button>
            </Tooltip>
          <Box
              sx={{
                overflowX: "auto",
                maxHeight: 540,
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "7px",
                  height: "7px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }}
            >
              <Table size="small" aria-label="members table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>No.</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>First Name</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Last Name</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Phone Contact</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Gender</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Date of Birth</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Card Number</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Savings Group</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Main Crop</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Language</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Land Size</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Community</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Cluster</b>
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Folder</b>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {everybody?.length > 0 && (
                  <TableRow sx={{ backgroundColor: '#e8f4f8' }}>
                    <TableCell align="left" colSpan={12}>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Total Members: {everybody.length}</b>
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
                  {[...everybody].reverse().map((row, index) => (
                    <TableRow
                      key={row.member_id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        backgroundColor: "#f5f3f4",
                      }}
                    >
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{everybody.length - index}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.firstname}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.lastname}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.phone}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.gender === 'male'?'Male':row.gender === 'female'?'Female':'Not set'}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.dob?formatDateToYearMonthDay(new Date(row.dob)): 'Not Set'}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.ghcardnumber}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.association_name}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.main_crop}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.farmer_language}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>
                            {row.land_size_acres <= 0 || !row.land_size_acres
                              ? "N/A"
                              : `${row.land_size_acres} acres`}
                          </b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.community}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{row.cluster}</b>
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Button
                          size="small"
                          color="success"
                          variant="contained"
                          sx={{
                            borderRadius: 2,
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                              backgroundColor: "#14213d",
                            },
                          }}
                          onClick={() => handlePsb(row)}
                        >
                          <FolderSharedRoundedIcon />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
        </Box>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Member"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              This action cannot be undone. NB: this will also delete member
              from all savings groups, all member accounts info will also be
              lost. Do you wish to continue?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    </div>
  );
};

export default AllMembers;
